/**
 * Normalise a Singapore phone number to an 8-digit string.
 *
 * Portal / OTP / WhatsApp login only — Customer Portal authentication currently
 * supports Singapore mobiles. Do NOT use this to gate commercial workflows
 * (e.g. Mark Won); overseas and missing phones are valid commercially.
 *
 * Handles all common formats:
 *   +65 1234 5678  →  12345678
 *   +6512345678    →  12345678
 *   12345678       →  12345678
 *   1234 5678      →  12345678
 *   65-1234-5678   →  12345678
 *
 * Returns null if the input is falsy or cannot be reduced to 8 digits.
 */
export function normalisePhone(raw: string | null | undefined): string | null {
  if (!raw) return null;
  // Strip everything except digits
  let digits = raw.replace(/\D/g, "");
  // Remove leading country code 65 if present and result is 10 digits
  if (digits.length === 10 && digits.startsWith("65")) {
    digits = digits.slice(2);
  }
  // Accept only 8-digit Singapore numbers
  if (digits.length !== 8) return null;
  return digits;
}

/**
 * Returns true if two phone strings refer to the same Singapore number.
 * Treats null/undefined/non-8-digit values as non-matching.
 */
export function phonesMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  const na = normalisePhone(a);
  const nb = normalisePhone(b);
  if (!na || !nb) return false;
  return na === nb;
}
